// Essentially Rover but for non-impressions
class EventTracker {
    constructor(options = {}) {
        this.config = {
            'debug' : false
        };
        for(const key in options) this.config[key] = options[key];
        this.adapterRegistry = {};
        this.classRegistry = {};
        this.tooltipRegistry = {};
        if (this.config['debug']) { 
            console.log("Event Tracker Loaded!");
        }
    }

    registerAdapter(eventName, className) {
        this.classRegistry[eventName] = className;
        this.adapterRegistry[eventName] = className.getTracking;
        this.tooltipRegistry[eventName] = className.getTooltip;
    }

    getAdapter(eventName) {
        return this.adapterRegistry[eventName].bind(this.classRegistry[eventName]) || this.defaultEventAdapter;
    }

    getTooltipFunction(eventName) {
        return this.tooltipRegistry[eventName].bind(this.classRegistry[eventName]) || this.defaultTooltip;
    }

    defaultEventAdapter(element, action = "Click", nonInteraction = false) {
        let data = {
            name : "Custom Event",
            props : {
                action: action || 'Click',
                location: element.closest('[data-location]').dataset.location || 'undefined',
                microIgnore: false,
                nonInteraction: nonInteraction
            }
        };
        if (this.config['debug']) { 
            console.log(data);
        }
        return data;
    }

    defaultTooltip(element) {
        data = this.defaultEventAdapter(element);
        gtagData = this.getGtagProps(data);
        tooltipContent = '<strong class="tooltipster-title">Google Analytics</strong><dl><dt>Category:</dt><dd>' + gtagData.event_category + '<dt>Action:</dt><dd>' + data.props.action + '</dd><dt>Label:</dt><dd>' + gtagData.event_label + '</dd></dl>';
        return tooltipContent;
    }

    getGtagProps( data ) {

        var name = data.name,
            props = data.props,
            action = props.action,
            label = props.label;

        if ( name == 'CTA' ) {
            if( props.location == "simple-offer" ) {
                label = ["Location: " + props.location, "Offer: " + props.offer, "Modifiers: " + props.modifiers];
            } else {
                label = ["Location: " + props.location, "Position: " + props.position, "Offer: " + props.offer, "Modifiers: " + props.modifiers];
            }

        } else if ( name == 'Button' ) {
            label = ["Location: " + props.location, "Offer: " + props.offer, "Modifiers: " + props.modifiers];

        } else if ( name == 'Reading' ) {
            label = ["Depth: " + props.depth];

            if ( action == '20_Seconds' ) {
                label = null;
            }

        } else if ( name == 'Video' ) {
            label = ["Location: " + props.location, "Position: " + props.position, "Offer: " + props.offer];

            if ( action == 'Watch' ) {
                label.push(["Progress: " + props.progress]);
            }

        } else if ( name == 'Form' ) {
            label = ["Step: " + props.step, "Location: " + props.location, "Offer: " + props.offer];

            if( action == 'Input' ) {
                label.push(["Field Name: " + props.field_name, "Valid: " + props.valid]);

            } else if ( action == 'step') {
                label.push(["Step: " + props.label]);
            }

        } else if ( name == 'Chat' ) {
            if ( action == 'Click' ) {
                label = null;
            }

        } else if ( name == 'Navigation' ) {
            if ( action == 'Click' ) {
                label = ["Location: " + props.location, "Copy: " + props.copy, "Order: " + props.order, "Modifiers: " + props.modifiers];
            }
        }

        label = (Array.isArray(label)) ? label.join(' | ') : label;

        //set cookie for cta_id that will be passed into Salesforce upon form submission
        if (name == 'CTA') {
            setCookie('cta_id', label, 365, '/');
        }

        var gtag_props = {
            'event_category' : name,
            'event_label' : label,
            'non_interaction' : props.nonInteraction
        }

        return gtag_props;
    }

}